export const delay = (ms: number) =>
	new Promise<Timer>((res) => {
		const timer = setTimeout(() => res(timer), ms);
	});
